import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import Caption from '../Caption'
import PopularServices from '../PopularServices'
import Button from '../Button'
import Col from "../Col"
import Container from "../Container"

const DashboardCards = ({servant_passports, linkOptions, cardTitle, catalogLink}) => {
  if (!linkOptions && !servant_passports){
    return null
  }
  return (
    <div className="popular-services-wrapper">
      <Container>
        <Col xs={6} sm={12} md={24} lg={24}>
          <Caption position={cardTitle.position}>{cardTitle.name}</Caption>
          <PopularServices linkOptions={linkOptions} servant_passports={servant_passports} />
          {catalogLink &&
            <Link className="button-wrapper button-wrapper__center" to={catalogLink}>
              <Button bsSize="lg" bsStyle="arrow-right">
                Все услуги
              </Button>
            </Link>
          }
        </Col>
      </Container>
    </div>
  )
}

{/* eslint-disable */}
DashboardCards.propTypes = {
  cardTitle: PropTypes.shape({
    name: PropTypes.string,
    position: PropTypes.string
  }).isRequired,
  catalogLink: PropTypes.string,
  linkOptions: PropTypes.array.isRequired,
  servant_passports: PropTypes.array.isRequired
}
{/* eslint-disable */}

DashboardCards.defaultProps = {
  catalogLink: null
}

export default DashboardCards



// WEBPACK FOOTER //
// ./components/DashboardCards/index.jsx